export const STEPS = {
    cliniciansAdd: 'clinicians-management/clinicians-add',
    nameLocation: 'clinicians-management/step-name-location',
    credentialVerification: 'clinicians-management/step-credential-verification',
    welcome: 'clinicians-management/step-welcome'
}
